export default __webpack_public_path__ + "static/media/1961.1caee019.png";